import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EndpointsConfig } from '../../../../config/endpoints.config';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SrcReservationDateSelService {
  constructor(private http: HttpClient) { }

  searchReservationStatus(request): Observable<any> {
    return this.http.post<any>(EndpointsConfig.reservation.searchReservationStatus, request);
  }
  searchReservationStatusByDay(request): Observable<any> {
    return this.http.post<any>(EndpointsConfig.reservation.searchReservationStatusByDay, request);
  }
  /* 20241129 #23420 add start */
  getNationalHoliday(request): Observable<any> {
    return this.http.post<any>(EndpointsConfig.common.getNationalHoliday, request);
  }
  /* 20241129 #23420 add end */
}
